import { lazy } from 'react';

export const LoadingPageLazy = lazy(() => import('./loading'));
